// extracted by mini-css-extract-plugin
module.exports = {"blocked":"d_c","loader":"d_d","blog":"d_n","blog__categoryItem__wrap":"d_p"};